import { mapActions, mapGetters, mapState } from 'vuex'
import $ from 'jquery'
import {
  FETCH_SEARCH_FILTERS,
  SET_ANALYST_SEARCH,
  FETCH_ANALYST_BIO,
  ADDTAB,
  LOAD_ANALYST_RESULT,
  STORE_ANALYST_TO_LOCALSTORAGE,
  SET_CURRENT_PAGE_ANALYST,
  SET_LOAD_MORE_STATUS_ANALYST,
  LOAD_MORE_RESULT_ANALYST,
  SET_ORDER_BY_ANALYST,
  SET_LOCALSTORAGE_SEARCH_FILTER_ANALYST
} from '@/store/actions.type'
import localStorage from '@/api/localStorage'
import loginmodel from '@/components/sign-askanlyst-popup.vue'
import searchResultPreview from '@/components/search-result-preview.vue'
import analystAskModal from '@/components/analystAskModal.vue'
import searchEntitledModal from '@/components/searchEntitledModal.vue'
import analystEntitledModal from '@/components/analystEntitledModal.vue'
import { SITE_URL } from '@/api/config'
import state from '@/store'
import { userAuthenticat } from '@/api'
import axios from 'axios'
import ThePlaceHolder from '@/components/ThePlaceHolder'
import { urlParam } from '@/helper'
export default {
  name: 'analyst',
  components: {
    loginmodel: loginmodel
  },
  created() {
    this.fetchfilter()
    this.onloadgetresult()
    window.addEventListener( 'scroll', this.handleScroll )
    this.settingHeight()
  },

  data() {
    return {
      category: urlParam.entitlementcategory ? decodeURI( urlParam.entitlementcategory ) : '',
      videoiframe: '',
      types: /(\.|\/)(mp3|mp4)$/i,
      seletedAnalyst: 'Any Analyst',
      seletedAvatar: '',
      analystname: '',
      analystDepartment: '',
      analystTitle: '',
      filtersLoading: false,
      limit: 10,
      reserchtype: [],
      searchresult: '',
      postcount: 0,
      currentpage: 1,
      loadmore: false,
      filtersLoading: false,
      searchResultsLoading: false,
      filters: {},
      orderby: [
        {
          value: 'desc',
          text: 'Most recent'
        },
        {
          value: 'asc',
          text: 'Least recent'
        }
      ],
      sort: 'desc',
      coverage: '',
      analystdec: '',
      analystemail: '',
      analystid: '',
      analystdescription: '',
      userData: this.$store.state.auth.user,
      anlystdel: 'email',
      analystcoverage: '',
      yourmessage: '',
      username: '',
      errormessage: '',
      errorusername: '',
      erroruseremailpassword: '',
      vimeoUrl: '',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  components: {
    searchResultPreview,
    ThePlaceHolder,
    analystAskModal,
    searchEntitledModal,
    analystEntitledModal
  },
  computed: {
    searchfilters() {
      return this.$store.state.searchresult.filters
    },
    fetchsearchResult() {
      this.postcount = this.$store.state.analyst.searchresult.postcount
      if ( this.$store.state.analyst.searchresult.posts ) {
        return this.$store.state.analyst.searchresult.posts
      }
      return ''
    },
    searchpostcounts() {
      this.postcount = this.$store.state.analyst.searchresult.postcount
      return this.$store.state.analyst.searchresult.postcount
    },
    changeLoadingStatus() {
      this.searchResultsLoading = this.$store.state.analyst.searchresultloading
      return this.$store.state.analyst.searchresultloading
    },
    setLoadmoreStatus() {
      this.loadmore = this.$store.state.analyst.loadmore
      return this.$store.state.analyst.loadmore
    }
  },
  methods: {
    ...mapState( {
      isLogin: state => !state.auth.isAuthenticated
    } ),
    ...mapActions( {
      fetchsearchfilters: FETCH_SEARCH_FILTERS,
      setsearchanalyst: SET_ANALYST_SEARCH,
      analystbio: FETCH_ANALYST_BIO,
      createRvTab: ADDTAB,
      setcurrentpage: SET_CURRENT_PAGE_ANALYST,
      onloadanalystposts: LOAD_ANALYST_RESULT,
      storagetolocalstoreage: STORE_ANALYST_TO_LOCALSTORAGE,
      setloadmore: SET_LOAD_MORE_STATUS_ANALYST,
      loadmoreposts: LOAD_MORE_RESULT_ANALYST,
      orderbysearch: SET_ORDER_BY_ANALYST,
      setlocalstoragetostore: SET_LOCALSTORAGE_SEARCH_FILTER_ANALYST
    } ),
    ...mapGetters( ['analystdetials', 'analystsearchstate', 'activetabid'] ),
    setanalystinfo() {
      var analystdetials = this.analystdetials()
      this.analystname = analystdetials.analystname
      this.seletedAnalyst = analystdetials.analystname
      this.seletedAvatar = analystdetials.avatar
      this.analystcoverage = analystdetials.analystcoverage
      this.analystdescription = analystdetials.analystdescription
      this.analystDepartment = analystdetials.analystdepartment
      this.analystTitle = analystdetials.analysttitle
      return this.analystdetials().analystemail
    },
    searchEntitledModalpopup( cat ) {
      if ( this.$store.state.auth.user.username ) {
        digitalData['entitledLockLink'] = cat
        _satellite.track( 'entitledContentPopUp' )
      }
      this.category = cat
    },
    selectAnlyst: function ( anlystobj ) {
      this.lineLimitpage()
      this.storagetolocalstoreage( anlystobj.name )
      // this.createTab(anlystobj.name, 'analyst', anlystobj.id)
      var analystDetials = []
      analystDetials['aid'] = anlystobj.id
      analystDetials['strack'] = true
      this.analystbio( analystDetials )
      this.setsearchanalyst( anlystobj.id )
      // console.log('analyst name', anlystobj.name)
      $( '.analystHeading.tabHeading' ).html( anlystobj.name )
      window.scrollTo( 0, 0 )
    },
    async createTab( categoryName, type, post ) {
      // console.log(categoryName)
      var tabobj = {}
      tabobj['type'] = type
      tabobj['categoryName'] = categoryName
      tabobj['post'] = post
      this.createRvTab( tabobj )
      if ( type == 'analyst' ) {
        // console.log('analyst', post)
        var analystDetials = []
        analystDetials['aid'] = post
        analystDetials['strack'] = false
        this.analystbio( analystDetials )
        this.setsearchanalyst( post )
      }

      // events.selectCurrentAcative(currentTab)
    },
    onloadgetresult: function () {
      var analystDetials = []
      analystDetials['track'] = false
      // this.analystbio( analystDetials )
      if ( urlParam.tab == 'analyst' ) {
        var analystid = urlParam.analystid ? urlParam.analystid : ''
        analystDetials['aid'] = analystid
        this.analystbio( analystDetials )
        this.setsearchanalyst( analystid )
        if ( urlParam.sort == 'asc' ) {
          this.setloadmore( true )
          this.orderbysearch( 'asc' )
        }
      } else {
        var searchfilter = localStorage.getlocalStorage( 'analystTab' )
        this.setlocalstoragetostore( JSON.parse( searchfilter ) )
        if ( searchfilter ) {
          this.onloadanalystposts( searchfilter )
          analystDetials['aid'] = JSON.parse( searchfilter ).analyst
          this.analystbio( analystDetials )
        }
      }
    },
    async fetchfilter() {
      this.filtersLoading = true
      await this.fetchsearchfilters()
      this.filtersLoading = false
    },
    selectOrderbyanalyst: function () {
      this.setloadmore( true )
      var researchtype = jQuery( '#rvorderbyanalyst' ).val()
      this.orderbysearch( researchtype )
    },
    hideModal() {
      this.$refs.myModalRef.hide()
    },
    async analyseSubmitevt() {
      this.loading = true
      axios
        .post( '' )
        .then( response => {
          // console.log(response)
          if ( response.status === 200 ) {
            this.$refs.modal.hide()
          }
        } )
        .catch( error => {
          // console.log(error)
        } )
    },
    lineLimitpage: function () {
      $( document ).ready( function () {
        store_contents()
        update_ellipsis()
      } )

      var store_contents = function () {
        $( '.ellipsis' ).each( function () {
          var p = $( this )
          p.data( 'ellipsis-storage', p.html() )
        } )
      }

      var update_ellipsis = function () {
        $( '.ellipsis' ).each( function () {
          var p = $( this )
          var max_line_count = p.data( 'ellipsis-max-line-count' )
          var line_height = p.html( '&nbsp' ).outerHeight()
          var max_height = max_line_count * line_height
          p.html( p.data( 'ellipsis-storage' ) )
          var p_height = p.outerHeight()

          while ( p_height > max_height ) {
            var content_arr = p.html().split( ' ' )
            content_arr.pop()
            content_arr.pop()
            content_arr.push( '...' )
            p.html( content_arr.join( ' ' ) )
            p_height = p.outerHeight()
          }
        } )
      }
    },

    handleScroll() {
      if ( this.activetabid() == 'analyst' || this.activetabid() == 'null' ) {
        var bottomOfWindow = false
        // if( $(window).scrollTop() > $(document).height() - $(window).height() ) {

        var scrollTop, consolevalue
        if (
          navigator.platform == 'iPad' ||
          ( navigator.userAgent.search( 'Safari' ) > 0 &&
            navigator.userAgent.search( 'Chrome' ) < 0 )
        ) {
          // consolevalue = 'document.body.scrollTop> window.innerHeight - document.documentElement.offsetHeight'
          scrollTop = Math.ceil( document.body.scrollTop )
        } else {
          scrollTop = Math.ceil( document.documentElement.scrollTop )
          consolevalue =
            'document.documentElement.scrollTop window.innerHeight - document.documentElement.offsetHeight'
        }
        //  console.log(scrollTop, window.innerHeight, document.documentElement.offsetHeight)

        if (
          scrollTop + window.innerHeight >=
          document.documentElement.offsetHeight
        ) {
          var bottomOfWindow = true
        }

        // console.log(consolevalue, scrollTop, window.innerHeight, document.documentElement.offsetHeight)
        var stateValue = this.analystsearchstate()
        //  console.log('bottomOfWindow ', bottomOfWindow)
        /*  console.log(
            bottomOfWindow,
            stateValue.loadmore,
            stateValue.searchresultloading,
            stateValue.searchfilters.currentpage,
            stateValue.searchresult.totalpages
          )
          */

        if (
          bottomOfWindow &&
          !stateValue.loadmore &&
          !stateValue.searchresultloading &&
          stateValue.searchfilters.currentpage <
            stateValue.searchresult.totalpages
        ) {
          var current_page = stateValue.searchfilters.currentpage + 1
          this.currentpage = current_page
          this.setcurrentpage( current_page )
          this.setloadmore( true )
          this.loadMoreSearchResult()
        }
      }
    },
    async loadMoreSearchResult() {
      await this.loadmoreposts()
    },
    settingHeight: function () {
      /*
      	Setting footer on bottom
      	*/
      if ( this.$store.state.appsetting.theme == 'd' ) {
        var hgt = $( window ).height()
        this.heightStyle = {
          minHeight: hgt + 'px'
        }
      } else if ( this.$store.state.appsetting.theme == 'l' ) {
        var hgt = $( window ).height() - 100
        this.heightStyle = {
          minHeight: hgt + 'px'
        }
      } else {
        var hgt = $( window ).height() - 100
        this.heightStyle = {
          minHeight: hgt + 'px'
        }
      }
    },
    iframeVideo( videoid ) {
      if ( navigator.userAgent.match( /(PANARAY iPad)/ ) ) {
        this.videoiframe = this.videoURL( videoid, false )
        this.$root.$emit( 'bv::show::modal', 'videomodal' )
        // window.open(videoSrc);
      } else {
        $( '.youTubeVideo' ).attr( 'src', this.vimeoUrl )
        this.videoiframe = this.videoURL( videoid, false )
        this.$root.$emit( 'bv::show::modal', 'videomodal' )
      }
    },
    videoURL: function ( src, feature ) {
      var dec = window.atob( src )
      var outputsrc = JSON.parse( dec )
      var video = ''
      if ( this.types.test( outputsrc ) ) {
        var video =
          '<video width="100%" height="100%" controls><source src="' +
          outputsrc +
          '" type="video/mp4"></video>'
      } else {
        var typesvideo = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/
        if ( outputsrc.match( typesvideo ) ) {
          var videoUrl = outputsrc.replace( /^.*?(\?|&)(v=([^&]+)).*$/i, '$3' )
          var urlv = 'https://www.youtube.com/embed/' + videoUrl
          var video =
            '<iframe class="youTubeVideo" width="100%" height="450" src="' +
            urlv +
            '"></iframe>'
        } else {
          var videoID = outputsrc.split( '/' )
          var videoIDVal = videoID[videoID.length - 1]
          if ( feature ) {
            return 'https://player.vimeo.com/video/' + videoIDVal
          }
          // var vimeourl =
          this.vimeoUrl = SITE_URL +
            'research-analyst-morning-call?id=' +
            videoID[videoID.length - 1]
          //	return 'https://player.vimeo.com/video/' + videoID[videoID.length - 1]
          var video =
            '<iframe class="youTubeVideo" width="100%" height="450" src="' +
            this.vimeoUrl +
            '" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" data-ready="true"></iframe>'
        }
      }
      return video
    },
    hideModal( id ) {
      this.$root.$emit( 'bv::hide::modal', id )
      $( '.youTubeVideo' ).attr( 'src', $( '.youTubeVideo' ).attr( 'src' ) )
      $( '.youTubeVideo' ).attr( 'src', '' )
    }
  },
  beforeUpdate() {
    this.lineLimitpage()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/analyst.js